import { hd, IGroupModel } from '@nx-fe/services';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

export class GroupDisplayState {
  isSingleGroup = false;
  lastSelectedGroup: IGroupModel = undefined;

  constructor(public groups: IGroupModel[], public lastSelectedGroupId: number) {
    this.isSingleGroup = !!groups && groups.length === 1;
    if (!!groups && lastSelectedGroupId !== undefined) {
      this.lastSelectedGroup = groups.find(p => p.groupId === lastSelectedGroupId);
    }
  }
}

export const computeLastSelectedTicketGroup = (groups: IGroupModel[], ticketConfig: hd.ITicketUserConfiguration) => {
  if (!groups || groups.length === 0) {
    return undefined;
  }

  if (!ticketConfig || !groups.find(p => p.groupId === ticketConfig.LastSelectedGroupId)) {
    return groups[0].groupId;
  }

  return ticketConfig.LastSelectedGroupId;
};

export const createGroupStateObserver = (
  groupObservable: Observable<IGroupModel[]>,
  ticketObservable: Observable<hd.ITicketUserConfiguration>
): Observable<GroupDisplayState> =>
  combineLatest([groupObservable, ticketObservable]).pipe(
    map(([groups, tickets]) => {
      return new GroupDisplayState(groups, computeLastSelectedTicketGroup(groups, tickets));
    })
  );
